import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, DatePicker, Form, Input, Select, Table } from "antd";
import "./work_order_allocation.css";
import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle";
import withWorkOrderAllocationLogic from "../../../components/hoc_work_order_allocation";

const WorkOrderAllocation: React.FC<any> = ({
    form,
    foremanOptions,
    handleDateChange,
    technicianData,
    handleForemanChange,
    navigate,
    transformStyle,
    Printbtn,
    Voidbtn,
    Submitbtn,
    InAllocate,
    TechnicianWorkOrderAllocation,
    warehouseCode
}) => {
    const serviceDate = Form.useWatch('service_date', form);
    const foreman = Form.useWatch('foreman', form);
    const isAllocateDisabled = !serviceDate || !foreman || !technicianData || technicianData.length === 0;

    return (
        <div id="id2o" style={transformStyle}>
            <div className="gjs-grid-row" id="isxh">
                <div className="gjs-grid-column" id="i9dl">
                    <Breadcrumb
                        items={[
                            {
                                href: "",
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_allocate_work_order",
                                title: (
                                    <>
                                        <span>Data Allocate Work Order</span>
                                    </>
                                ),
                            },
                            {
                                title: "Work Order Allocation",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="izjrz">
                <div className="gjs-grid-column" id="ii6p">
                    <Button className="gr-button">
                        <FaPlusCircle style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        New
                    </Button>
                    <Button className="gr-button" >
                        <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Submit
                    </Button>
                    <Button className="gr-button" >
                        <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Void
                    </Button>
                    <Button className="gr-button">
                        <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Print
                    </Button>
                </div>
            </div>
            <div className="gjs-grid-row" id="izjrz">
                <div className="gjs-grid-column" id="ii6p">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Service Date"
                            name="service_date"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Please select service date!' }]}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                format="DD/MM/YYYY"
                                onChange={handleDateChange}
                            />
                        </Form.Item>
                        <Form.Item label="Foreman" name="foreman" style={{ marginBottom: "5px" }}>
                            <Select
                                showSearch
                                placeholder="Select Foreman"
                                style={{ width: "100%" }}
                                options={foremanOptions}
                                optionFilterProp="label"
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                onChange={handleForemanChange}
                            />
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className="gjs-grid-row" id="i4foj">
                <div className="gjs-grid-column" id="ijomu">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '210px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Total Use Technican Time"
                            name="total_technican_time"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Current Time"
                            name="current_time"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className="gjs-grid-row" id="ifduy">
                <div className="gjs-grid-column" id="itqcl">
                    <Table
                        columns={TechnicianWorkOrderAllocation}
                        dataSource={technicianData}
                        pagination={false}
                        bordered
                        rowKey={(record, index) => index?.toString() || ''}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="iu2ms">
                <div className="gjs-grid-column" id="i2ilu">
                   <Button
                        className="gr-button"
                        onClick={() => navigate("/dashboard/allocate_work_order", { 
                            state: { 
                                foreman: form.getFieldValue('foreman'),
                                warehouse_code: warehouseCode
                            } 
                        })}
                        disabled={isAllocateDisabled}
                    >
                        <InAllocate style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Allocate
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default withWorkOrderAllocationLogic(WorkOrderAllocation);